<template>
    <div>
        <img src="../../assets/newImg/point_top.png" class="point-top" alt="" />
        <div class="point">
            <div class="point-all">{{dataSource.my_integral}}</div>
            <div class="point-txt">我的积分</div>
            <div class="point-intrduce row-flex row-center-center">
                <div class="intrduce row-flex row-center-center" @click="$router.push({path:'/newborn/goods?id=4'})">规则介绍</div>
                <div style="width:21px"></div>
                <div class="intrduce row-flex row-center-center" @click="$router.push('/user/intDetail')">积分明细</div>
            </div>
        </div>
        <div class="order-all row-flex row-between-center">
            <div class="order-left row-flex row-around-center">
                <router-link :to="{ path: '/order/list/' + 1+'?shop_type=3' }" class="order-list">
                <div class="number" v-if="dataSource.wait_send>0">{{dataSource.wait_send}}</div>
                    <img src="../../assets/newImg/order_dfh.png" alt="" />
                    <div>待发货</div>
                </router-link>
                <router-link class="order-list" :to="{ path: '/order/list/' + 2+'?shop_type=3' }">
                <div class="number" v-if="dataSource.receive>0">{{dataSource.receive}}</div>
                    <img
                        src="../../assets/newImg/order_dsh.png"
                        alt=""
                        style="width:26px;height:23px"
                    />
                    <div>待收货</div>
                </router-link>
                <router-link class="order-list" :to="{ path: '/order/list/' + 3+'?shop_type=3' }">
                <div class="number" v-if="dataSource.evaluate>0">{{dataSource.evaluate}}</div>
                    <img src="../../assets/newImg/order_dpj.png" alt="" />
                    <div>待评价</div>
                </router-link>
            </div>
            <router-link :to="{ path: '/order/list/'+8+'?shop_type=3' }" class="order-right row-flex row-center-center text-color">
                全部订单
            </router-link>
        </div>
        <div class="inter-work row-flex row-start-center">做任务赚积分</div>
        <div class="list-work row-flex row-between-center">
            <div class="work-left">
                <div class="work-login row-flex row-center-center">
                    <img src="../../assets/newImg/point_1.png" alt="" />
                    <div>每日登录</div>
                </div>
                <div class="number">{{dataSource.today_login}}</div>
            </div>
            <div class="work-right row-flex row-center-center">已获得</div>
        </div>
        <div class="list-work row-flex row-between-center">
            <div class="work-left">
                <div class="work-login row-flex row-center-center">
                    <img src="../../assets/newImg/point_1.png" alt="" />
                    <div>购买商品</div>
                </div>
                <div class="number">{{dataSource.buy_product}}</div>
            </div>
            <div class="work-right row-flex row-center-center" @click="$router.push('/integral')">去购买</div>
        </div>
        <div class="list-work row-flex row-between-center">
            <div class="work-left">
                <div class="work-login row-flex row-center-center">
                    <img src="../../assets/newImg/point_1.png" alt="" />
                    <div>评论商品</div>
                </div>
                <div class="number">{{dataSource.comments_product}}</div>
            </div>
            <div class="work-right row-flex row-center-center" @click="$router.push('/order/list/3')">去评论</div>
        </div>
        <div class="list-work row-flex row-between-center">
            <div class="work-left">
                <div class="work-login row-flex row-center-center">
                    <img src="../../assets/newImg/point_1.png" alt="" />
                    <div>转发商品</div>
                </div>
                <div class="number">{{dataSource.forwarding}}</div>
            </div>
            <div class="work-right row-flex row-center-center" @click="$router.push('/integral')">{{dataSource.share==0 ? '去转发':'已转发'}}</div>
        </div>
        <div class="inter-work row-flex row-start-center" v-if="productList.length>0">推荐积分商品</div>
        <div class="productList" ref="container">
            <div class="list acea-row row-between-wrapper" >
                <div @click="goDetail(item)" v-for="(item, index) in productList" :key="index" class="item"  :title="item.store_name">
                    <div class="pictrue" >
                        <img :src="item.image"  />
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
                        <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
                    </div>
                    <div class="text" >
                        <div class="name line1">{{ item.store_name }}</div>
                        <div class="name line1" style="color:#999999;font-size:12px;height:20px;line-height:20px">
                            {{ item.store_info }}
                        </div>
                        <div class="go-shop">
                            <div class="money font-color-red" >
                                <span class="num">{{ item.price }}积分</span>
                            </div>
                            <div class="go">
                                立即兑换
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:20px"></div>
    </div>
</template>
<style lang="scss" scoped>
.index .header {
    background: #d01112;
}
.index .header .logo {
    width: 2.12rem;
    height: 0.72rem;
}
.index .header .logo img {
    object-fit: contain;
}
.index .header .search {
    width: 4.56rem;
    height: 0.56rem;
    padding: 0 0.4rem;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 0.32rem;
    color: #ffffff;
}
.productList .list .item .text .money .num {
    font-size: 0.3rem;
}
.index .header .search .iconfont {
    margin-right: 0.28rem;
}
.contents {
    width: 6rem;
    height: 100vh;
    background: #fff;
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    .mod_list li {
        position: relative;
        line-height: 25px;
        padding: 10px;
    }
    .mod_list .li_line {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
    }
    .mod_list .li_line .big {
        height: 25px;
        max-width: 250px;
        overflow: hidden;
        font-size: 16px;
        color: #333;
        text-overflow: ellipsis;
    }
    .mod_list .li_line .right {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        margin-left: 5px;
        text-align: right;
        font-size: 12px;
        color: #999;
    }
    .words_10 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
        text-align: right;
        max-width: 110px;
    }
    .mod_list .tags_selection {
        position: relative;
        margin: 0;
        padding: 10px 0 0 10px;
    }
    .mod_list .tags_selection::before {
            content: "";
            position: absolute;
            z-index: 1;
            pointer-events: none;
            background-color: #e5e5e5;
            height: 1px;
            left: 0;
            right: 0;
            top: 0;
            left: 10px;
        }
        .mod_list .sub_list.tags_selection {
    display: none;
}
.tags_selection .option.selected a:after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 15px;
    height: 15px;
    border-radius: 0 0 2px 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTOQ4POQ5PPrV1f///+dGSO17ff3u7/Kio+lcXvW4uZrptW4AAAACdFJOUwB/timhlQAAAH1JREFUGNNdzkEOQDAQheG6Qo/whNjjBBWs9QbiCFzExl4cFG1HzOvuz5fpjDHqZTqNJQYxiEEMYhCDGMQgBjGIQQxiEOPPRf114NxJx+lrkw5cDXvqyEsv/z1cT2U3p365aY9R9r3T3q1n6ri7cXJPPM23qeVyudfq1gxi3DyiIhPh30TpAAAAAElFTkSuQmCC) no-repeat;
    background-size: 15px auto;
    overflow: hidden;
    z-index: 1;
}
.tags_selection .option.selected a {
    color: #e4393c;
    background-color: #fdf0f0;
    height: 30px;
    line-height: 30px;
}
    .tags_selection .option {
    box-sizing: border-box;
    float: left;
    width: 33.33%;
    padding-right: 10px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    overflow: hidden;
}
.tags_selection .option a {
    position: relative;
    display: block;
    padding: 0 5px;
    color: #666;
    background-color: #f7f7f7;
    border-radius: 4px;
    text-align: center;
}
}
.productList .nav .item .integer-filter-icon {
    width: 0.36rem;
    height: 0.36rem;
}
.productList .nav .item {
    display: flex;
    justify-content: center;
    align-items: center;
}
.index .banner {
    width: 100%;
    margin: 0 auto;
    height: 3rem !important;
}
.index .banner img {
    height: 3rem;
}
.productList .list .item .text {
    padding: 0.2rem 0.17rem 0.1rem 0.17rem;
}
.filterlayer_bottom_buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    z-index: 100;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -1px 2px 0 rgba(0,0,0,.07);
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.btn_close {
    position: relative;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    flex: none;
    width: 50px;
    background: #fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTM3NzczMzM/Pz9TU1MzMzMzMzMzMzMzMzM7Ozs3Nzc3NzczMzMzMzM/Pz83NzczMzNPxTqsAAAAQdFJOUwBm1icN4oz27TNBUcWzGnbbkATbAAAA1ElEQVQ4y9XUyw6EIAwF0IpUFAbl/792KKMOjxbcygrLMWkuDQAvWRMu8uGC073HEES5hID5hySrIy9Jcj4vCLJxoFmZnC5r+hOLR1k7Yumj679bybtWSu6Ud7iT6ErZc1GqS5JTWr7XS44cwE7SOXJ7f5CSfOCiRHK4PxjOkKckL2sIGvvEIY4luXWe15HckgNIcuu4eL5u106Wf1fue64n677s2S/rbJtA45jsUqbz2HGSJsG4th9nqvlQvPtJlQVD08pnRjOcReGVk27BKf+W1xu+l8MOwbyeFd0AAAAASUVORK5CYII=) 50% no-repeat;
    background-size: 20px;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.btn_close:after {
    content: "";
    position: absolute;
    z-index: 1;
    pointer-events: none;
    background-color: #e5e5e5;
    width: 1px;
    top: 0;
    bottom: 0;
    right: 0;
    right: -6px;
    top: 8px;
    bottom: 7px;
}

.filterlayer_bottom_buttons .filterlayer_bottom_button {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    font-size: 16px;
    height: 49px;
    line-height: 49px;
    text-align: center;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.bg_1 {
    color: #333;
    background-color: #fff;
}
.filterlayer_bottom_buttons .filterlayer_bottom_button.bg_2 {
    color: #fff;
    background-color: #e4393c;
}
.productList .nav {
    position: relative;
    top: 0;
    justify-content: space-between;
    box-shadow: 0px 4px 10px 0px rgba(173, 39, 39, 0.06);
}
.productList .list .item .text .money {
    margin-top: 0;
}
.productList .list {
    margin-top: 0;
}
.go-shop {
    /* height: 33px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.go-shop .go {
    width: 1.28rem;
    height: 0.4rem;
    background: #d01112;
    border-radius: 13px;
    line-height: 0.4rem;
    color: #fff;
    background: #d01112;
    font-size: 12px;
    text-align: center;
}
.productList .list .item {
    box-shadow: 0px 2px 30px 0px rgba(157, 157, 157, 0.2);
}
.searchGood .search .input {
    background: rgba(255, 255, 255, 0.4);
    input {
        color: #fff;
        &::placeholder {
            color: #fff;
        }
    }
    .iconfont {
        color: #fff;
    }
}
.productList .list .item.on {
    margin-top: 0.2rem;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
}
.searchGood .search {
    margin-top: 0;
    height: 0.94rem;
    line-height: 0.94rem;
}
.searchGood .search .bnt {
    color: #fff;
}
.searchGood .search .input {
    line-height: 0.66rem;
}
</style>
<style lang="scss" scoped>
.point-top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 182px;
    z-index: -1;
}
.point {
    text-align: center;
    color: #ffffff;
    .point-all {
        font-size: 30px;
        font-weight: 600;
        line-height: 40px;
    }
    .point-txt {
        font-size: 18px;
        padding-bottom: 8px;
    }
    .point-intrduce {
        .intrduce {
            width: 62px;
            height: 24px;
            border: 1px solid #ffffff;
            border-radius: 14px;
            font-size: 12px;
        }
    }
}
.order-all {
    margin: 15px 15px 0 15px;
    height: 90px;
    background: #ffffff;
    border-radius: 10px;
    .order-left {
        width: 100%;
        .order-list {
            margin: 0 auto;
            text-align: center;
            width: 25%;
            position: relative;
            img {
                width: 22px;
                height: 22px;
            }
            div {
                font-size: 13px;
                text-align: center;
                color: #666666;
                padding-top: 7px;
            }
            .number{
                position: absolute;
                right: 10px;
                top: -10px;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border:1px solid #d01112;
                font-size: 13px;
                color: #d01112;
                padding: 0;
            }
        }
    }
    .order-right {
        background: url("../../assets/newImg/point_order_bg.png") no-repeat;
        background-size: 100% 100%;
        width: 25%;
        height: 90px;
        font-weight: 600;
        box-shadow: -5px 0 5px 0 #ececec;
    }
}
.inter-work {
    height: 48px;
    color: #222;
    font-size: 18px;
    font-weight: 600;
    padding-left: 15px;
}
.list-work {
    margin: 0 15px 11px 15px;
    height: 80px;
    background: #ffffff;
    border-radius: 10px;
    .work-left {
        .work-login {
            background: url("../../assets/newImg/point_bg.png") no-repeat;
            background-size: 100% 100%;
            width: 116px;
            height: 29px;
            img {
                width: 15px;
                height: 15px;
            }
            div {
                color: #333;
                padding-left: 8px;
                font-weight: 600;
                font-size: 15px;
            }
        }
        .number {
            font-size: 13px;
            padding-top: 13px;
            padding-left: 15px;
        }
    }
    .work-right {
        width: 83px;
        height: 33px;
        background: #d01112;
        border-radius: 32px;
        box-shadow: 0px 3px 4px 0px #f8d9d9;
        margin-right: 16px;
        color: #ffffff;
        font-size:15px ;
    }
}
</style>
<script>
import { getHostProductsTj } from "@api/store";
import {myIntegral} from '@api/user';
export default {
    name: "myPoints",
    data() {
        return {
            dataSource:{},
            productList: [],
            page:1,
            limit:10,
            shop_type:3
        };
    },
    methods: {
        integral(){
          myIntegral().then(res=>{
              this.dataSource=res.data
          })
        },
        
        get_product_list() {
            var that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            let page=that.page,
            limit=that.limit,
            shop_type=that.shop_type;
            getHostProductsTj(page,limit,shop_type).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data);
                that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
                that.page = that.page + 1;
            });
        },
            goDetail(item) {
        this.$router.push({
          path: "/detail/" + item.id + "?shop_type=3"
        });
    },
    },
    mounted() {
        this.integral();
        this.get_product_list();
    },
};
</script>
